import React, { Component } from "react";
import axios from "axios";
import apiUrl from "../../config/config";
import classnames from "classnames";
import Select from "react-select";
import $ from "jquery";
import Modal from "react-modal";
import "./patientinfo.css";
import { MDBDataTable } from "mdbreact";
import ProgressBtn from "../../components/common/ProgressButton";
import TopNav from "../../components/common/TopNav";
import SideBar from "../../components/common/SideBar";
import Dropdown from "react-dropdown";
import "react-dropdown/style.css";
import LinearProgress from "@material-ui/core/LinearProgress";
import { FormatAlignLeft, Label } from "@material-ui/icons";
import {Toaster,toast} from 'react-hot-toast';
Modal.setAppElement("#root");

class PatientInfoWeb extends Component {
  constructor() {
    super();
    const menus = [
          { title: "Verifier Home", url: "/verifier-home" },
          { title: "Patient list", url: "/patient-list" },
          { title: "Labled Patients", url: "/labled-patients" },
        
        ];
        if (localStorage.getItem("verifiertype") === "8") {
          menus.splice(2, 0, { title: "Patient-hold", url: "/patient-hold" });
        }
        if (localStorage.getItem("verifierid") === "5d6df589c3d92110fccfde7c") {
          menus.splice(3, 0, { title: "Device Deatils", url: "/device-details" });
        }
        if (localStorage.getItem("verifiertype") === "8") {
          menus.splice(4, 0, { title: "Support Home", url: "/support-home" });
        }
        if (localStorage.getItem("verifiertype") === "8") {
          menus.splice(5, 0, { title: "QC Home", url: "/qc_home" });
        }
        if (localStorage.getItem("verifiertype") === "8") {
          menus.splice(6, 0, { title: "Support Web", url: "/support-homeweb" });
        }
    this.state = {
      menus,

      profileLink: "verifier-profile",
      patients: [],
      serial_no: "",
      currentPage: 1,
      totalPages: 1,
      errors: {},
      userid: "",

      hospital: "",
      ip_op: "",
      BatteryPercentage: "",
      backup: "",
      patient_name: "",
      phone: "",

      indication: "",

      doctors: [],
      doctor_id: "",
      doctor_name: "Choose",
      data: { rows: [] },
      prog_data: 0,
      loading: false,
      time: "",
      RecordingStatus: "",
      serial_no: "",
      device_id: "",
      Mac_id: "",
      customer_details: "",

      activity: "Rest",
      act_duration: "5",
      addNote: "",
      selectedDoctor: null,
      search: "",
      pageSize: 50,
      sortField: null,
      sortDirection: "asc",
      pacemaker: false,
    };
    this.selectItem = this.selectItem.bind(this);
    this.preventDefault = this.preventDefault.bind(this);
    this.fetchPatients = this.fetchPatients.bind(this);
    this.handleDoctorChange = this.handleDoctorChange.bind(this);
    // this.handlePageChange = this.handlePageChange.bind(this);
  }

  componentDidMount() {
    this.fetchPatients(this.state.currentPage);
    function capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
    var newstat = this;

    /*socket.on('connect', function(){console.log('connected')});
    socket.on('connect_error', function(err){console.log(err)});
    socket.on('data', function(data){


      newstat.setState({"loading":true});
      
      console.log(newstat.state.loading)
    });
    socket.on('disconnect', function(){console.log('disconnected')});*/
    this.fetchNotifications();
    this.notificationInterval = setInterval(this.fetchNotifications, 2000);
  }
  handleDoctorChange = (selectedOption) => {
    this.setState({ selectedDoctor: selectedOption });
    // console.log("Selected doctor:", selectedOption);
    // Perform any action needed with the selected doctor
  };
  handleSearch = (event) => {
    const searchValue = event.target.value.toLowerCase();
    this.setState({ search: searchValue });
  };
  handleSort = (field) => {
    const { sortField, sortDirection, data } = this.state;
    const direction =
      sortField === field && sortDirection === "asc" ? "desc" : "asc";

    const sortedRows = [...data.rows].sort((a, b) => {
      if (a[field] < b[field]) return direction === "asc" ? -1 : 1;
      if (a[field] > b[field]) return direction === "asc" ? 1 : -1;
      return 0;
    });

    this.setState({
      sortField: field,
      sortDirection: direction,
      data: { ...data, rows: sortedRows },
    });
  };
  handlePageSizeChange = (event) => {
    const pageSize = parseInt(event.target.value, 10);
    this.setState({ pageSize });
  };

  invertEcg(e) {
    const userid = e.currentTarget.id;
    console.log(e.currentTarget.id);
    axios.get(
      `https://web.mybiocalculus.com/html/welcome/analyzeAll/?userid=${userid}&&type=/home/ubuntu/web_analysis/single_invert.py`
    );
    axios.get(
      `https://web.mybiocalculus.com/html/welcome/analyzeAll/?userid=${userid}&&type=/home/ubuntu/web_analysis/single_invert.py`
    );
  }
    fetchNotifications = async () => {
      try {
        const res = await axios.get("https://web.mybiocalculus.com:3002/api/common/getMessages");
        // console.log("Notification data:", res.data);
        
        // Iterate through notifications and handle unread ones
        for (let notification of res.data) {
          if (notification.viewed === "0") {
            toast.success(notification.description);
    
            // Update the notification status
            const updateNotification = await axios.post(`${apiUrl}api/common/updateViewedstatus`, {
              Messageid: notification._id,
            });
            
            // console.log("Notification updated:", updateNotification);
          }
        }
      } catch (err) {
        console.error("Error fetching notifications:", err);
      }
    };
  fetchPatients = async (pageNumber) => {
    try {
      const res = await axios.get(
        apiUrl + "api/users/getSupportPatientsNewmodalWeb?page=" + pageNumber
      );
      const patients = res.data;

      const data = {
        columns: [
          { label: "SL NO", field: "slno", sort: "asc", width: 50 },
          {
            label: "PATIENT NAME",
            field: "patientName",
            sort: "asc",
            width: 200,
          },
          { label: "Trigger", field: "Trigger", sort: "asc", width: 250 },
          { label: "Doctor", field: "doctorName", sort: "asc", width: 200 },
          { label: "Phone", field: "phone", sort: "asc", width: 200 },
          { label: "Serial No", field: "serial_no", sort: "asc", width: 250 },
          { label: "Gender", field: "gender", sort: "asc", width: 50 },
          { label: "Hospital", field: "hospital", sort: "asc", width: 200 },
          { label: "Duration", field: "duration", sort: "asc", width: 100 },
          { label: "Mac ID", field: "Mac_id", sort: "asc", width: 400 },
          {
            label: "Battery Percentage",
            field: "BatteryPercentage",
            sort: "disabled",
            width: 100,
          },
          {
            label: "Backup Status",
            field: "backup",
            sort: "disabled",
            width: 200,
          },
          { label: "Symptoms", field: "symptoms", sort: "asc", width: 200 },
          { label: "IP/OP", field: "ip_op", sort: "asc", width: 200 },
          { label: "Patient ID", field: "device_id", sort: "asc", width: 200 },
          {
            label: "Recording Status",
            field: "RecordingStatus",
            sort: "asc",
            width: 200,
          },
          {
            label: "Customer",
            field: "customer_details",
            sort: "asc",
            width: 200,
          },
          { label: "Created On", field: "created", sort: "asc", width: 200 },
          { label: "Invert", field: "Invert", sort: "disabled", width: 200 },
          { label: "Status", field: "status", sort: "disabled", width: 200 },
          { label: "Action", field: "action", sort: "disabled", width: 200 },
          { label: "Diary", field: "diary", sort: "disabled", width: 200 },
        ],
        rows: [],
      };

      patients.forEach((patient, i) => {
        // console.log("patient!!!!!!!!!", patient);
        var anl_btn_txt = "Analyze";
        var anl_btn_class = "btn-danger";
        var gen_btn_txt = "Not Analyzed";
        var gen_btn_class = "btn-danger";
        var report_link = "#";
        var report_link_target = "";
        var report_status = patient.report_status;
        window.backup_status = patient.backup_status;
        const recordingStatus = patient.RecordingStatus;

        // Function to render status message based on RecordingStatus
        const renderStatusMessage = () => {
          switch (recordingStatus) {
            case 0:
              return " recording Not started";
            case 1:
              return "Recording Mode";
            case 3:
              return "Data uploaded";
            default:
              return "Unknown status";
          }
        };
        const createdData = patient.created_at.split("T");
        const customerDetailsText =
          patient.customer_details && patient.customer_details.length > 0
            ? patient.customer_details
                .map((detail) => detail.customer_details)
                .join(" ")
            : "No customer details available";

        data.rows.push({
          slno: i + 1,
          patientName: patient.name,
          Trigger: (
            <React.Fragment>
              <a href="#" style={{ display: "flex", flexDirection: "column" }}>
                <button
                  type="button"
                  id={patient._id}
                  onClick={this.Trigger_old}
                  className="btn btn-warning mr-20"
                  data-toggle="modal"
                >
                  Trigger Old
                </button>
                <button
                  type="button"
                  id={patient._id}
                  onClick={this.Trigger}
                  className="btn btn-warning mr-20"
                  data-toggle="modal"
                >
                  Trigger New
                </button>
              </a>
            </React.Fragment>
          ),
          doctorName: patient.doctor_name,
          phone: patient.phone,
          serial_no: <Serialno patient={patient} />,
         
          gender: patient.gender,
          hospital: patient.hospital,
          activeMorning: patient.ActiveMorning || "_",
          activeEvening: patient.ActiveEvening || "_",
          issuereported: patient.issueReported || "_",
          duration: patient.exp_device_use_days,
          Mac_id: patient.Mac_id,
          BatteryPercentage: <YourComponent patient={patient} />,
          backup: <BackupButton patient={patient} />,
          symptoms: patient.indication,
          ip_op: patient.ip_op,
          device_id: patient.device_id,
          RecordingStatus: renderStatusMessage(),
          customer_details: customerDetailsText,
          created: createdData[0],
          Invert: (
            <React.Fragment>
              <a href="#">
                <button
                  type="button"
                  id={patient._id}
                  onClick={this.invertEcg}
                  className="btn btn-warning mr-20"
                  data-toggle="modal"
                >
                  Invert
                </button>
              </a>
            </React.Fragment>
          ),
          Status: (
            <React.Fragment>
              <a href="#">
                <button
                  type="button"
                  id={patient._id}
                  className="btn btn-primary  mr-20"
                >
                  {gen_btn_txt}
                </button>
              </a>
            </React.Fragment>
          ),
          action: (
            <React.Fragment>
              <a href="#">
                <button
                  type="button"
                  id={patient._id}
                  onClick={() => this.getInfo(patient._id)}
                  className="btn btn-warning mr-20"
                  data-toggle="modal"
                  data-target="#editInfoModal"
                >
                  Edit
                </button>
              </a>
            </React.Fragment>
          ),
          diary: (
            <React.Fragment>
              <a href="#">
                <button
                  type="button"
                  id={patient._id}
                  className="btn btn-warning mr-20"
                  data-toggle="modal"
                  data-target="#editDiaryModal"
                >
                  Diary
                </button>
              </a>
            </React.Fragment>
          ),
        });
      });

      this.setState({
        patients: patients,
        data: data,
        totalPages: Math.ceil(patients.length / this.state.pageSize),
      });
    } catch (err) {
      console.error(err);
    }
  };

  onSubmit = (e) => {
    e.preventDefault();
    const settings = {
      userid: this.state.userid,
      nor_minhr: this.state.nor_minhr,
      nor_maxhr: this.state.nor_maxhr,
      qtcformula: this.state.qtcformula,
      qtcvalue_min: this.state.qtcvalue_min,
      qtcvaluemax: this.state.qtcvaluemax,
      qrswidth_min: this.state.qrswidth_min,
      qrswidth_max: this.state.qrswidth_max,
      qrsamp_min: this.state.qrsamp_min,
      qrsamp_max: this.state.qrsamp_max,
      stelevation: this.state.stelevation,
      pwidth_min: this.state.pwidth_min,
      pwidth_max: this.state.pwidth_max,
      pamp_min: this.state.pamp_min,
      pamp_max: this.state.pamp_max,
      stdepression: this.state.stdepression,
      twidth_min: this.state.twidth_min,
      twidth_max: this.state.twidth_max,
      tamp_min: this.state.tamp_min,
      tamp_max: this.state.tamp_max,
      printerval_min: this.state.printerval_min,
      printerval_max: this.state.printerval_max,
      tachyhr_lower: this.state.tachyhr_lower,
      tachyhr_upper: this.state.tachyhr_upper,
      bradyhr_lower: this.state.bradyhr_lower,
      bradyhr_upper: this.state.bradyhr_upper,
      pauselength: this.state.pauselength,
      graph_gen: this.state.graph_gen,
    };

    // console.log(settings);
    axios
      .post(apiUrl + "api/patients/updateSettings", settings)
      .then((res) => {
        $("#closePopup").click();
      })
      .catch((err) => {
        console.log(err);
      });
  };
  onSubmitDiary = (e) => {
    e.preventDefault();
    var uid = this.props.userid;
    var did = this.props.databaseid;
    var finTime = document.getElementById("addTime").value;

    const info = {
      id: this.props.userid,
      datetime: finTime,
      diary_notes: this.state.addNote,
      act_duration: this.state.act_duration,
      activity: this.state.activity,
    };
    // console.log("info", info);
    axios
      .post(apiUrl + "api/patients/addDiary", info)
      .then((res) => {
        // console.log(res.data);
        $(".closePopup").click();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  onSubmitInfo = (e) => {
    e.preventDefault();
    const info = {
      userid: this.state.userid,
      hospital: this.state.hospital,
      ip_op: this.state.ip_op,
      doctorid: this.state.selectedDoctor.value,
      indication: this.state.indication,
      phone: this.state.phone,
      device_id: this.state.device_id,
      RecordingStatus: this.state.RecordingStatus,
      Mac_id: this.state.Mac_id,
      customer_details: this.state.customer_details,
      BatteryPercentage: this.state.BatteryPercentage,
      backup: this.state.backup,
      hyper_lipidemia: this.state.pacemaker,
    };

    axios
      .post(apiUrl + "api/patients/updateMoreInfo", info)
      .then((res) => {
        $(".closePopup").click();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  onChange = (e) => {
    var err = this.state.errors;
    delete err[e.target.name];
    this.setState({ [e.target.name]: e.target.value });
  };

  preventDefault(e) {
    e.preventDefault();
  }
  Trigger(e) {
    var userid = e.currentTarget.id;

    axios
      .post(
        `${apiUrl}api/graph/Trigger_new`, {
          userid: userid
        }
      )
      .then((res) => {
        // console.log(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }
 Trigger_old(e) {
    var userid = e.currentTarget.id;
    console.log(
      "https://web.mybiocalculus.com/html/welcome/triggeruserdata/?userid=" +
        userid
    );
    axios
      .post(
        `${apiUrl}api/graph/Trigger_old`,{userid}
      )
      .then((res) => {
        // console.log(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }
  nextPage = () => {
    const { currentPage } = this.state;
    const nextPage = currentPage + 1;
    this.setState({ currentPage: nextPage });
    this.fetchPatients(nextPage);
  };

  prevPage = () => {
    const { currentPage } = this.state;
    const prevPage = currentPage - 1;
    if (prevPage > 0) {
      this.setState({ currentPage: prevPage });
      this.fetchPatients(prevPage);
    }
  };
  setInfo(e) {
    var diary_id = e.currentTarget.id;
    this.state.diary_note_id = diary_id;
    /*var arr=this.search(this.state.diary_notes,diary_id);
     this.setState({time:arr[0].datetime,note:arr[0].diary_notes});
     console.log("diary_id",this.state.diary_note_id);*/
  }
  getInfo = (userid) => {
    axios
      .get(apiUrl + "api/users/alldoctors")
      .then((res) => {
        this.setState({ doctors: res.data });
      })
      .catch((err) => {
        this.setState({ doctors: [] });
      });

    this.setState({
      smoking: "",
      diabetes: "",
      weight: "",
      hyper_tension: "",
      hyper_lipidemia: "",
      indication: "",
      cardiac_surgery: "",
      thyroid_function: "",
    });

    this.setState({ userid: userid });
    axios
      .get(apiUrl + "api/patients/getPatinetAdditionalInfo?userid=" + userid)
      .then((res) => {
        var data = res.data[0];
        this.setState({
          device_id: data.device_id,
          RecordingStatus: data.RecordingStatus,
          customer_details: data.customer_details,
          Mac_id: data.Mac_id,
          indication: data.indication,
          BatteryPercentage: data.BatteryPercentage,
          backup: data.backup,
          hospital: data.hospital,
          ip_op: data.ip_op,
          phone: data.phone,
          patient_name: data.name,
          doctor_name: data.doctor_name,
          pacemaker: data.hyper_lipidemia,
          doctor_id: data.doctorid,
          selectedDoctor: {
            value: data.doctorid,
            label: data.doctor_name,
          },
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  selectItem(e) {
    var userid = e.currentTarget.id;
    this.setState({ userid: userid });
    this.setState({
      nor_minhr: "",
      nor_maxhr: "",
      qtcformula: "",
      qtcvalue_min: "",
      qtcvaluemax: "",
      qrswidth_min: "",
      qrswidth_max: "",
      qrsamp_min: "",
      qrsamp_max: "",
      stelevation: "",
      pwidth_min: "",
      pwidth_max: "",
      pamp_min: "",
      pamp_max: "",
      stdepression: "",
      twidth_min: "",
      twidth_max: "",
      tamp_min: "",
      tamp_max: "",
      printerval_min: "",
      printerval_max: "",
      tachyhr_lower: "",
      tachyhr_upper: "",
      bradyhr_lower: "",
      bradyhr_upper: "",
      pauselength: "",
      graph_gen: "",
    });
    axios
      .get(apiUrl + "api/patients/settings?userid=" + userid)
      .then((res) => {
        var data = res.data;
        this.setState(data);
      })
      .catch((err) => {
        console.log(err);
      });
  }
  exportToCSV = () => {
    const { data, sortField, sortDirection } = this.state;

    // Define columns to exclude (you can modify this list based on your needs)
    const excludedColumns = [
      "Trigger",
      "serial_no",
      "backup",
      "Status",
      "action",
      "diary",
      "BatteryPercentage",
    ];

    // Sort the rows if necessary
    const sortedRows = [...data.rows].sort((a, b) => {
      if (sortField && sortDirection) {
        const aValue = a[sortField];
        const bValue = b[sortField];
        if (sortDirection === "asc") {
          return aValue > bValue ? 1 : -1;
        } else {
          return aValue < bValue ? 1 : -1;
        }
      }
      return 0;
    });

    // Filter the rows if needed (e.g., excluding rows with certain conditions)
    const filteredRows = sortedRows.filter((row) => {
      // Example: exclude rows with 'Status' as 'Inactive'
      return row.Status !== "Inactive"; // Modify this based on your needs
    });

    // Prepare headers by excluding specified columns
    const headers = Object.keys(filteredRows[0]).filter(
      (header) => !excludedColumns.includes(header)
    );

    // Convert rows to CSV format, excluding unwanted columns
    const csvRows = [];
    csvRows.push(headers.join(",")); // Add the header row

    filteredRows.forEach((row) => {
      const values = headers.map((header) => {
        const value = row[header] === null ? "" : row[header]; // Handle null values
        return `"${value}"`; // Wrap each value in quotes to handle commas
      });
      csvRows.push(values.join(","));
    });

    // Create CSV string
    const csvString = csvRows.join("\n");

    // Create a temporary link element to trigger the download
    const link = document.createElement("a");
    link.href = "data:text/csv;charset=utf-8," + encodeURIComponent(csvString);
    link.target = "_blank";
    link.download = "filtered_sorted_data.csv";

    // Trigger the download
    link.click();
  };

  render() {
    if (localStorage.jwtToken == undefined) {
      window.location.href = "/";
    }
    // const { errors, doctors, selectedDoctor,data, search, pageSize, sortField, sortDirection } = this.state;
    // Inside render() method
    const {
      errors,
      doctors,
      selectedDoctor,
      data,
      search,
      pageSize,
      sortField,
      sortDirection,
    } = this.state;

    // Ensure `data` and `data.rows` are defined and check each value before calling `toString()`
    const filteredRows =
      data && data.rows && Array.isArray(data.rows)
        ? data.rows.filter(
            (row) =>
              Object.values(row).some(
                (value) =>
                  // Safely check if value is not undefined or null before calling `toString()`
                  value &&
                  value.toString().toLowerCase().includes(search.toLowerCase())
              ) ||
              // Check if customer_details contains the search value
              (row.customer_details &&
                row.customer_details
                  .toString()
                  .toLowerCase()
                  .includes(search.toLowerCase()))
          )
        : []; // Fallback to empty array if data.rows is undefined

    // Slice rows for pagination
    const displayedRows = filteredRows.slice(
      (this.state.currentPage - 1) * this.state.pageSize,
      this.state.currentPage * this.state.pageSize
    );

    // console.log("selecteddoctors:", selectedDoctor);
    const options = doctors.map((doctor) => ({
      value: doctor._id,
      label: doctor.name,
    }));

    // let doctorsList =
    //   this.state.doctors.length > 0 &&
    //   this.state.doctors.map((item, i) => {
    //     return (
    //       <option
    //         key={i}
    //         value={item._id}
    //         selected={this.state.doctor_name == item.name}
    //       >
    //         {item.name}
    //       </option>
    //     );
    //   }, this);

    return (
      <div className="wrapper theme-1-active box-layout pimary-color-green">
        <TopNav profileLink={this.state.profileLink} />
        <SideBar menus={this.state.menus} />
        <div className="right-sidebar-backdrop"></div>
        <div className="page-wrapper">
          <div className="container-fluid">
            <div id="editDiaryModal" className="modal fade" role="dialog">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                    >
                      &times;
                    </button>
                    <h4 className="modal-title text-center">Add Diary Notes</h4>
                    <form method="post" onSubmit={this.onSubmitDiary}>
                      <div className="modal-body">
                        <div className="row row-sm-offset">
                          <br />
                          <div className="col-md-6 multi-horizontal">
                            <div className="form-group">
                              <label className="form-control-label mbr-fonts-style display-7">
                                TIME
                              </label>
                              <div
                                className="input-group date"
                                id="datetimepicker2"
                              >
                                <input
                                  id="addTime"
                                  type="text"
                                  className={classnames("form-control", {
                                    errors: errors.time,
                                  })}
                                  onBlur={this.onChange}
                                  value={this.state.time}
                                  name="time"
                                />
                                <span className="input-group-addon">
                                  <span className="fa fa-calendar"></span>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row row-sm-offset">
                          <br />
                          <div className="col-md-6 multi-horizontal">
                            <div className="form-group">
                              <label className="form-control-label mbr-fonts-style display-7">
                                Activity
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                name="activity"
                                onChange={this.onChange}
                                value={this.state.activity}
                              />
                            </div>
                          </div>
                          <div className="col-md-6 multi-horizontal">
                            <div className="form-group">
                              <label className="form-control-label mbr-fonts-style display-7">
                                Duration
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                name="act_duration"
                                onChange={this.onChange}
                                value={this.state.act_duration}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row row-sm-offset">
                          <br />

                          <div className="col-md-12 multi-horizontal">
                            <div className="form-group">
                              <label className="form-control-label mbr-fonts-style display-7">
                                Note
                              </label>
                              <textarea
                                type="textarea"
                                className="form-control"
                                name="addNote"
                                onChange={this.onChange}
                                value={this.state.addNote}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="modal-footer">
                        <div className="row row-sm-offset">
                          <div className="col-md-6 multi-horizontal">
                            <button type="submit" className="btn btn-success">
                              Submit
                            </button>
                          </div>
                          <div className="col-md-6 multi-horizontal text-left">
                            <button
                              id=""
                              type="button"
                              className="btn btn-default closePopup"
                              data-dismiss="modal"
                            >
                              Close
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div id="editInfoModal" className="modal fade" role="dialog">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                    >
                      &times;
                    </button>
                    <h4 className="modal-title text-center">
                      Edit Patient Information
                    </h4>
                  </div>
                  <form method="post" onSubmit={this.onSubmitInfo}>
                    <div className="modal-body">
                      <div className="row row-sm-offset">
                        <br />
                        <div className="col-md-6 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              Name
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="patient_name"
                              onChange={this.onChange}
                              value={this.state.patient_name}
                            />
                          </div>
                        </div>
                        <div className="col-md-6 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              Doctor Name
                            </label>

                            <Select
                              options={options} // Provide the options
                              value={selectedDoctor} // Controlled component value
                              onChange={this.handleDoctorChange} // Handle selection
                              placeholder="Search Doctor"
                              classNamePrefix="react-select"
                              styles={{
                                control: (base) => ({
                                  ...base,
                                  borderColor: errors.doctor_id
                                    ? "red"
                                    : base.borderColor,
                                }),
                              }}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="row row-sm-offset">
                        <br />
                        <div className="col-md-6 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              Hospital Name
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="hospital"
                              onChange={this.onChange}
                              value={this.state.hospital}
                            />
                          </div>
                        </div>
                        <div className="col-md-6 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              Phone
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="phone"
                              onChange={this.onChange}
                              value={this.state.phone}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="row row-sm-offset">
                        <br />
                        <div className="col-md-6 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              Support Person
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="supportP"
                              onChange={this.onChange}
                              value={this.state.supportP}
                            />
                          </div>
                        </div>
                        <div className="col-md-6 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              {" "}
                              Support Time{" "}
                            </label>
                            <div
                              className="input-group date"
                              id="datetimepicker1"
                            >
                              <input
                                type="text"
                                className={classnames("form-control", {
                                  errors: errors.supportT,
                                })}
                                onBlur={this.onChange}
                                value={this.state.supportT}
                                name="supportT"
                              />
                              <span className="input-group-addon">
                                <span className="fa fa-calendar"></span>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row row-sm-offset">
                        <br />
                        <div className="col-md-6 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              Payment
                            </label>
                            <select
                              name="payment"
                              className="form-control"
                              value={this.state.payment}
                              onChange={this.onChange}
                            >
                              <option value="">Choose </option>
                              <option value="Unpaid">Unpaid</option>
                              <option value="Paid">Paid</option>
                            </select>
                          </div>
                        </div>
                        <div className="col-md-6 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              Priority
                            </label>
                            <select
                              name="priority"
                              className="form-control"
                              value={this.state.priority}
                              onChange={this.onChange}
                            >
                              <option value="">Choose </option>
                              <option value="high">High</option>
                              <option value="medium">Medium</option>
                              <option value="low">Low</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="row row-sm-offset">
                        <br />
                        <div className="col-md-6 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              Symptoms
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="indication"
                              onChange={this.onChange}
                              value={this.state.indication}
                            />
                          </div>
                        </div>
                        <div className="col-md-6 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              Pacemaker
                            </label>
                            <select
                              name="priority"
                              className="form-control"
                              value={this.state.pacemaker}
                              onChange={(e) => {
                                if (e.target.value === "true") {
                                  this.setState({ pacemaker: true });
                                } else if (e.target.value === "false") {
                                  this.setState({ pacemaker: false });
                                }
                              }}
                            >
                              <option value="true">Yes</option>
                              <option value="false">No</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <div className="row row-sm-offset">
                        <div className="col-md-6 multi-horizontal">
                          <button type="submit" className="btn btn-success">
                            Submit
                          </button>
                        </div>
                        <div className="col-md-6 multi-horizontal text-left">
                          <button
                            id=""
                            type="button"
                            className="btn btn-default closePopup"
                            data-dismiss="modal"
                          >
                            Close
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="row" style={{ marginTop: "2.25%" }}>
              <div className="col-sm-12">
                <div
                  className="panel panel-default card-view"
                  style={{ marginTop: "-1%" }}
                >
                  <div className="panel-heading">
                    <div
                      className="pull-right"
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      <input
                        type="text"
                        placeholder="Search patients..."
                        value={this.state.search}
                        onChange={this.handleSearch}
                        style={{
                          marginRight: "10px",
                          color: "black",
                          border: "none",
                          padding: "5px",
                          borderRadius: "4px",
                        }}
                      />

                      <select
                        onChange={this.handlePageSizeChange}
                        value={this.state.pageSize}
                        style={{
                          color: "black",
                          padding: "5px",
                          borderRadius: "4px",
                        }}
                      >
                        <option value="50">50</option>
                        <option value="100">100</option>
                        <option value="500">500</option>
                        <option value="1500">1500</option>
                      </select>
                      <button
                        onClick={this.exportToCSV}
                        style={{
                          marginLeft: "10px",
                          padding: "10px",
                          backgroundColor: "#4CAF50",
                          color: "white",
                          border: "none",
                          borderRadius: "5px",
                        }}
                      >
                        Export to CSV
                      </button>
                    </div>

                    <div className="clearfix"></div>
                  </div>
                  <div className="panel-wrapper collapse in">
                    <div className="panel-body">
                      <div style={{ overflowX: "auto" }}>
                        <div style={{ overflowX: "auto" }}>
                          <table className="table">
                            <thead>
                              <tr>
                                <th onClick={() => this.handleSort("slno")}>
                                  SL NO
                                </th>
                                <th
                                  onClick={() => this.handleSort("device_id")}
                                >
                                  Patient ID
                                </th>
                                <th
                                  onClick={() => this.handleSort("patientName")}
                                >
                                  PATIENT NAME
                                </th>
                                <th onClick={() => this.handleSort("created")}>
                                  Created On
                                </th>
                                <th onClick={() => this.handleSort("phone")}>
                                  Phone
                                </th>
                                <th
                                  onClick={() => this.handleSort("doctorName")}
                                >
                                  Doctor
                                </th>
                                <th
                                  onClick={() => this.handleSort("serial_no")}
                                >
                                  Serial No
                                </th>
                                <th
                                  onClick={() => this.handleSort("serial_no")}
                                >
                                  Serial No
                                </th>
                           
                                <th
                                  onClick={() =>
                                    this.handleSort("RecordingStatus")
                                  }
                                >
                                  Recording Status
                                </th>
                                <th
                                  onClick={() =>
                                    this.handleSort("customer_details")
                                  }
                                >
                                  Customer details
                                </th>
                                <th onClick={() => this.handleSort("hospital")}>
                                  Hospital
                                </th>
                                <th>Active Morning</th>
                                <th>Active Evening</th>
                                <th
                                  onClick={() =>
                                    this.handleSort("issuereported")
                                  }
                                >
                                  Issue Reported
                                </th>
                                <th
                                  onClick={() =>
                                    this.handleSort("BatteryPercentage")
                                  }
                                >
                                  Battery Percentage
                                </th>
                                <th onClick={() => this.handleSort("duration")}>
                                  Duration
                                </th>
                                <th onClick={() => this.handleSort("ip_op")}>
                                  IP/OP
                                </th>

                                <th onClick={() => this.handleSort("gender")}>
                                  Gender
                                </th>

                                <th onClick={() => this.handleSort("Trigger")}>
                                  Trigger
                                </th>

                                <th onClick={() => this.handleSort("Mac_id")}>
                                  Mac ID
                                </th>

                                <th onClick={() => this.handleSort("backup")}>
                                  Backup Status
                                </th>
                                <th onClick={() => this.handleSort("symptoms")}>
                                  Symptoms
                                </th>

                                
                                <th onClick={() => this.handleSort("Trigger")}>
                                  Invert
                                </th>
                                <th onClick={() => this.handleSort("Status")}>
                                  Status
                                </th>
                                <th onClick={() => this.handleSort("action")}>
                                  Action
                                </th>
                                <th onClick={() => this.handleSort("diary")}>
                                  Diary
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {displayedRows.length > 0 ? (
                                displayedRows.map((row, index) => (
                                  <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{row.device_id}</td>

                                    <td>{row.patientName}</td>
                                    <td>{row.created}</td>

                                    <td>{row.phone}</td>

                                    <td>{row.doctorName}</td>
                                    <td>{row.serial_no}</td>
                                    <td>{row.serial_no}</td>
                                   
                                    <td>{row.RecordingStatus}</td>

                                    <td>{row.customer_details}</td>
                                    <td>{row.hospital}</td>
                                    <td>{row.activeMorning}</td>
                                    <td>{row.activeEvening}</td>

                                    <td>{row.issuereported}</td>
                                    <td>{row.BatteryPercentage}</td>
                                    <td style={{ textAlign: "center" }}>
                                      {row.duration}
                                    </td>
                                    <td>{row.ip_op}</td>
                                    <td>{row.gender}</td>

                                    <td>{row.Trigger}</td>
                                    <td>{row.Mac_id}</td>
                                    <td>{row.backup}</td>
                                    <td>{row.symptoms}</td>
                                    <td>{row.Invert}</td>
                                    <td>{row.Status}</td>
                                    <td>{row.action}</td>
                                    <td>{row.diary}</td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td
                                    colSpan="22"
                                    style={{ textAlign: "center" }}
                                  >
                                    No data available
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div className="pagination-container">
                        <button
                          className="btn btn-primary"
                          onClick={this.prevPage}
                          disabled={this.state.currentPage === 1}
                        >
                          Previous
                        </button>
                        <span className="current-page">
                          Page {this.state.currentPage} of{" "}
                          {this.state.totalPages}
                        </span>
                        <button
                          className="btn btn-primary"
                          onClick={this.nextPage}
                          // disabled={
                          //   this.state.currentPage === this.state.totalPages
                          // }
                        >
                          Next
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
class YourComponent extends Component {
  state = {
    showModal: false,
    batteryPercentage: null,
  };

BatteryPercentageClicked = (e) => {
    var userid = e.currentTarget.id;
    axios
      .get(`${apiUrl}api/common/getbatterypercentage?userid=${userid}`)
      .then((res) => {
        console.log(res.data);
        this.setState({ batteryPercentage: res.data.output, showModal: true });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };
  handleCloseModal = () => {
    this.setState({ showModal: false });
  };

  render() {
    const { patient } = this.props;
    const { showModal, batteryPercentage, currentPage, errors } = this.state;

    return (
      <>
        <button
          type="button"
          className="btn btn-danger"
          id={patient._id}
          onClick={this.BatteryPercentageClicked}
          style={{ marginLeft: "10px" }}
        >
          {patient.BatteryPercentage}%
        </button>

        <Modal
          isOpen={showModal}
          onRequestClose={this.handleCloseModal}
          contentLabel="Battery Percentage"
          style={{
            content: {
              color: "black",
              width: "50%",
              maxWidth: "800px",
              margin: "auto",
            },
          }}
        >
          <h2 style={{ color: "black" }}>Battery Percentage</h2>
          {batteryPercentage !== null ? (
            <p style={{ color: "black" }}>
              Battery percentage is:{" "}
              {batteryPercentage.split("\n").map((item, key) => {
                return (
                  <span key={key}>
                    {item}
                    <br />
                  </span>
                );
              })}
            </p>
          ) : (
            <p style={{ color: "black" }}>Loading...</p>
          )}
          <button onClick={this.handleCloseModal}></button>
        </Modal>
      </>
    );
  }
}
class Serialno extends Component {
  state = {
    showModal: false,
    serialno: null,
  };

  serialnoClicked = (e) => {
    console.log(e.currentTarget.id);
    var mac_id = e.currentTarget.id;

    axios
      .get(
       `${apiUrl}api/users/getSubsribe`,
       { params: { mac_id } }
      )
      .then((res) => {
        console.log(res.data);
        this.setState({ serialno: res.data.data, showModal: true });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  handleCloseModal = () => {
    this.setState({ showModal: false });
  };

  render() {
    const { patient } = this.props;
    const { showModal, serialno, currentPage, errors } = this.state;

    return (
      <>
        <button
          type="button"
          className="serialno_button"
          id={patient.Mac_id}
          onClick={this.serialnoClicked}
        >
          {patient.serial_no}
        </button>

        {serialno && (
          <Modal
            isOpen={showModal}
            onRequestClose={this.handleCloseModal}
            contentLabel="Records"
            style={{
              content: {
                color: "black",
                width: "60%",
                margin: "auto",
                marginTop: "6%",
              },
            }}
          >
            <h2 style={{ color: "black" }}>Records</h2>

            <p style={{ color: "black", fontSize: "15px" }}>
              {serialno
                .replace(/{"response":200}/g, "") // Remove {"response":200} from the string
                .split("\n")
                .map((item, key) => (
                  <span key={key}>
                    {item}
                    <br />
                    <br />
                  </span>
                ))}
            </p>
          </Modal>
        )}
      </>
    );
  }
}
class BackupButton extends Component {
  state = {
    backup: null,
  };
backupClicked = (e) => {
    const userid = e.currentTarget.id;
    axios
      .post(
        `${apiUrl}api/common/ChangeBackupStatus`,{
          userid:userid
        }
      )
      .then((res) => {
        console.log("res.data" + res.data);
        this.setState({ backup: res.data });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  render() {
    const { patient } = this.props;
    return (
      <button
        type="button"
        className="btn btn-danger mr-20"
        id={patient._id}
        onClick={this.backupClicked}
      >
        {patient.backup_status}
      </button>
    );
  }
}

export default PatientInfoWeb;
